import * as React from 'react'
import { cn } from '@/lib/utils'
import { VariantProps, cva } from 'class-variance-authority'

const paragraphVariants = cva('text-sm text-on-surface self-stretch', {
  variants: {
    weight: {
      medium: 'font-medium',
      regular: 'font-normal'
    }
  },
  defaultVariants: {
    weight: 'regular'
  }
})

interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement>, VariantProps<typeof paragraphVariants> {}

const ParagraphText = React.forwardRef<HTMLParagraphElement, ParagraphProps>(({ className, weight, ...props }, ref) => {
  return <p className={cn(paragraphVariants({ weight }), className)} ref={ref} {...props} />
})

export { ParagraphText }
